import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-cobalt/[0.06] px-5 py-12 sm:py-20" data-id="element-26" data-mp="gx6mk1kjg47t">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="vt63m1pmlep3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-28" data-mp="vu7h0cu46d9z">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-29" data-mp="qtjotnu5fqe6">
            🎁 4 Expert Bonuses — Included Today
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-30" data-mp="zuhkniuforlo">
            No extra cost. Yours the moment you join.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-31" data-mp="1eicej2k6h20c">
          {bonuses.map((bonus, i) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-6 shadow-sm shadow-cobalt/5 sm:p-7" data-id="element-32" data-mp="19lly2e4go4ee" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-33" data-mp="3ts7314kioiqi">
                <span className="rounded-md bg-cobalt px-2.5 py-1 text-[11px] font-bold tracking-wide text-white" data-id="element-34" data-mp="2lcoq50sxhrh">
                  {bonus.badge}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-35" data-mp="cjs4xcyaj6m7">
                  {bonus.icon}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-36" data-mp="gklvke34azis">
                {bonus.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-37" data-mp="lcvnu0rpgbo8">{bonus.description}</p>
              <div className="mt-5 flex items-center justify-between" data-id="element-38" data-mp="qaf6rdzclcmi">
                <span className="text-sm text-ink/50 line-through" data-id="element-39" data-mp="vbkxj69g6pte">{bonus.value}</span>
                <span className="rounded-full bg-cobalt px-3 py-1 text-xs font-bold text-white" data-id="element-40" data-mp="108l1nbmqlihv">
                  INCLUDED TODAY
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}